<div class="ws-step">
  <div class="ws-step-header">
    <h3>Products & Services</h3>
    <p class="text-muted">Select the products or services your team sells. These will be available when creating quotations etc.</p>
  </div>

  <div class="ws-step-body">
    @for (product of products; track product.name) {
      <div class="ws-item-card" [ngClass]="{'selected': product.selected, 'opacity-50': isAlreadyCreated(product)}">
        @if (!isAlreadyCreated(product)) {
          <input type="checkbox" class="form-check-input ws-item-toggle" [checked]="product.selected" (change)="toggleProduct(product)" />
        } @else {
          <i class="bi bi-check-circle-fill text-success ws-item-toggle"></i>
        }
        <div class="ws-item-content">
          <div class="d-flex align-items-center gap-2">
            <span class="ws-item-name">{{ product.name }}</span>
            <span class="ws-chip" [ngClass]="product.type === 'PRODUCT' ? 'ws-chip-product' : 'ws-chip-service'">
              {{ product.type }}
            </span>
          </div>
          @if (product.category) {
            <div class="ws-item-meta">{{ product.category }}</div>
          }
          @if (isAlreadyCreated(product)) {
            <div class="ws-item-meta text-success">Already created</div>
          }
        </div>
        @if (!isAlreadyCreated(product)) {
          <button class="btn btn-sm btn-link text-danger" (click)="removeProduct(product)"><i class="bi bi-x-lg"></i></button>
        }
      </div>
    }

    @if (!products.length) {
      <div class="ws-empty-state">
        <i class="bi bi-box"></i>
        <p>No products suggested. Add your own or provide feedback.</p>
      </div>
    }

    <!-- Add new product -->
    <div class="d-flex align-items-center gap-2 mt-3">
      <input class="form-control form-control-sm" [(ngModel)]="newProductName" placeholder="Add product/service..." (keyup.enter)="addProduct()" />
      <select class="form-select form-select-sm" style="width: 120px;" [(ngModel)]="newProductType">
        <option value="PRODUCT">Product</option>
        <option value="SERVICE">Service</option>
      </select>
      <button class="btn btn-sm btn-outline-primary" (click)="addProduct()" [disabled]="!newProductName.trim()">Add</button>
    </div>

    <!-- Feedback section -->
    <div class="ws-feedback-section">
      <div class="ws-feedback-label">Want different products? Tell AI:</div>
      <textarea [(ngModel)]="feedback" placeholder="e.g. We sell home loans, personal loans, and insurance products. Add those instead."></textarea>
      <div class="ws-feedback-actions">
        <button class="btn btn-sm btn-outline-primary" (click)="submitFeedback()" [disabled]="!feedback.trim()">
          <i class="bi bi-stars me-1"></i> Regenerate with AI
        </button>
      </div>
    </div>

    <div class="ws-save-row">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Save & Continue
      </button>
    </div>
  </div>
</div>
